import styled from 'styled-components';

import { StyledRewardLock as DefaultStyledRewardLock } from './reward-lock-icon.styled.default';

export * from './reward-lock-icon.styled.default';

export const StyledRewardLock = styled(DefaultStyledRewardLock)`
  > div {
    background-color: ${Styles.color.primary};
    ::before,
    ::after {
      border-color: ${Styles.color.primary};
    }
  }
`;
